(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-tabs"] && !Shopify.designMode) return;
  try {
    

(function () {
  document.querySelectorAll('.promo-tabs').forEach(function (root) {

    const tabs   = root.querySelectorAll('.promo-tabs__tab');
    const panels = root.querySelectorAll('.promo-tabs__panel');

    // ── Tab 切换 ──────────────────────────────────────────
    function switchTab(tabSlug) {
      tabs.forEach(t => t.classList.toggle('is-active', t.dataset.tab === tabSlug));
      panels.forEach(p => {
        const isActive = p.dataset.panel === tabSlug;
        p.classList.toggle('is-active', isActive);

        // 清除非活跃 panel 的 scroll 监听
        if (!isActive && p._scrollHandler) {
          window.removeEventListener('scroll', p._scrollHandler);
          p._scrollHandler = null;
        }

        if (isActive) observeAnchors(p);
      });
    }

    tabs.forEach(function (tab) {
  tab.addEventListener('click', function () {
    // 关闭 mega menu
    document.querySelectorAll('.mega-menu').forEach(function (menu) {
      menu.style.display = 'none';
    });
    switchTab(this.dataset.tab);
  });
});

    // ── 锚点高亮（scroll 事件，passive）──────────────────
    function observeAnchors(panel) {
      // 清除旧 observer 和 scroll 监听
      if (panel._observer) panel._observer.disconnect();
      if (panel._scrollHandler) {
        window.removeEventListener('scroll', panel._scrollHandler);
      }

      const anchorLinks = panel.querySelectorAll('.promo-tabs__anchor-link');
      const sections    = panel.querySelectorAll('.promo-tabs__section');

      function onScroll() {
        const scrollY  = window.scrollY;
        const offset   = 120; // tab bar + anchor nav 总高度

        let currentId = null;

        sections.forEach(function (section) {
          if (section.offsetTop - offset <= scrollY) {
            currentId = section.id;
          }
        });

        anchorLinks.forEach(function (link) {
          const isMatch = link.getAttribute('href') === '#' + currentId;
          link.classList.toggle('is-active', isMatch);
          if (isMatch) {
            const nav = panel.querySelector('.promo-tabs__anchornav');
            nav.scrollLeft = link.offsetLeft - (nav.offsetWidth / 2) + (link.offsetWidth / 2);
          }
        });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      panel._scrollHandler = onScroll;

      // 初始化高亮
      onScroll();
    }

    // ── 初始化第一个 panel ────────────────────────────────
    const firstPanel = root.querySelector('.promo-tabs__panel.is-active');
    if (firstPanel) observeAnchors(firstPanel);

  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-bottom-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-bottom-promo')) {
    class StickyBottomPromo extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.sectionId) return;

        this.sectionId = this.dataset.sectionId;
        this.surface = this.querySelector('[class*="__surface"]');
        this.closeBtn = this.querySelector('[data-close]');
        this.shopLink = this.querySelector('[data-shop-link]');
        this.storageKey = `sticky-bottom-promo-${this.sectionId}`;

        this.dismissed = sessionStorage.getItem(this.storageKey) === '1';
        this.footerVisible = false;
        this.scrolledEnough = false;
        this.bgLoaded = false;
        this.designMode = window.Shopify && Shopify.designMode;
        this.SCROLL_THRESHOLD = 120;

        this.onScroll = this.throttle(this.handleScroll.bind(this), 80);
        this.onResize = this.throttle(() => {
          this.checkFooterVisible();
          this.maybeLoadBackground();
          this.updateVisibility();
        }, 200);

        this.closeBtn?.addEventListener('click', this.handleClose.bind(this));
        this.shopLink?.addEventListener('click', this.handleShopClick.bind(this));

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });

        this.observeFooter();
        this.bindAnchorLink();
        this.handleScroll();

        if (this.designMode) {
          this.classList.add('is-visible');
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.footerObserver?.disconnect();
      }

      getFooterElement() {
        if (this.footerEl?.isConnected) return this.footerEl;

        this.footerEl =
          document.querySelector('.shopify-section--footer') ||
          document.querySelector('footer.footer')?.closest('.shopify-section') ||
          document.getElementById('shopify-section-footer');

        return this.footerEl;
      }

      observeFooter() {
        const footer = this.getFooterElement();
        if (!footer) return;

        this.footerObserver = new IntersectionObserver(
          () => this.checkFooterVisible(),
          { threshold: [0, 0.01, 0.1] }
        );

        this.footerObserver.observe(footer);
      }

      checkFooterVisible() {
        const footer = this.getFooterElement();
        if (!footer) {
          this.footerVisible = false;
          return;
        }

        const rect = footer.getBoundingClientRect();
        this.footerVisible = rect.top <= window.innerHeight;
      }

      bindAnchorLink() {
        if (!this.shopLink) return;
        const firstAnchor = document.querySelector('.promo-tabs__anchor-link');
        if (firstAnchor?.href) {
          this.shopLink.href = firstAnchor.getAttribute('href');
        }
      }

      handleShopClick(event) {
        const href = this.shopLink?.getAttribute('href');
        if (!href || href === '#') return;

        event.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        window.location.href = href;
      }

      handleClose() {
        this.dismissed = true;
        sessionStorage.setItem(this.storageKey, '1');
        this.updateVisibility();
      }

      handleScroll() {
        this.scrolledEnough = window.scrollY > this.SCROLL_THRESHOLD;
        this.checkFooterVisible();
        this.updateVisibility();
      }

      updateVisibility() {
        const shouldShow =
          this.designMode ||
          (!this.dismissed && this.scrolledEnough && !this.footerVisible);

        this.classList.toggle('is-visible', shouldShow);

        if (shouldShow) {
          this.maybeLoadBackground();
        }
      }

      maybeLoadBackground() {
        if (this.bgLoaded || !this.surface || !this.dataset.bg) return;
        if (!window.matchMedia('(min-width: 750px)').matches) return;

        this.surface.style.backgroundImage = `url("${this.dataset.bg}")`;
        this.bgLoaded = true;
      }

      throttle(fn, wait) {
        let timeout = null;
        let last = 0;
        return (...args) => {
          const now = Date.now();
          const remaining = wait - (now - last);
          if (remaining <= 0) {
            last = now;
            fn(...args);
          } else {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
              last = now;
              fn(...args);
            }, remaining);
          }
        };
      }
    }

    customElements.define('sticky-bottom-promo', StickyBottomPromo);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const promo = document.querySelector(
      `sticky-bottom-promo[data-section-id="${event.detail.sectionId}"]`
    );
    if (!promo) return;

    sessionStorage.removeItem(`sticky-bottom-promo-${event.detail.sectionId}`);
  });

  } catch(e) { console.error(e); }
})();
})();
